'use strict';
var parent = require('../../stable/instance/concat');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/instance/concat.js
// module id = 529
// module chunks = 13